import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 1rem 0;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-self: stretch;
`;

export const InfoPanel = styled.div`
  ${({ theme: { colors } }) => `
    position: relative;
    border: 1px solid ${colors("chrome")};
    height: 10rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    margin: 0.25rem;
    &.selected {
      background: ${colors("link", 0.5)};
      color: ${colors("link")};
    }
    &:hover,
    &.active {
      background: ${colors("chrome")};
      color: ${colors("background")};
    }
    &.drop-hover {
      border: 2px dashed ${colors("link")};
    }
  `}
`;

export const GearButton = styled.button`
  ${({ theme: { colors } }) => `
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    padding: 0.25rem;
    border: none;
    background: transparent;
    color: inherit;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.15s;
    ${InfoPanel}:hover &,
    &:focus-visible {
      opacity: 1;
    }
    &:hover {
      color: ${colors("link")};
    }
    @media (hover: none) {
      opacity: 1;
    }
  `}
`;

export const Panels = styled.div`
  display: flex;
  justify-content: space-between;
  overflow: scroll;
  margin: 1rem 0;
  padding: 0.5rem;
`;

export const PanelStyles = styled(Panels)``;
export const PanelStyle = styled(InfoPanel)`
  ${({ theme: { colors } }) => `
  cursor: grab;
  width: 5rem;
  height: 5rem;
  &:active {
    cursor: grabbing;
    background-color: ${colors("link")};
  }
    `}
`;

export const Ghost = styled.div`
  ${({ theme: { colors } }) => `
  position: fixed;
  pointer-events: none;
  z-index: 999;
  transform: translate(-50%, -50%);
    ${PanelStyle} {
      background-color: ${colors("link")};
    }
  `}
`;
